// Minimal EXIF GPS reader — enough to pull lat/long off a phone JPEG before
// the downscale pass strips metadata. Returns "lat, lng" (5 decimals) or null;
// never throws.

const gpsFromTiff = (view, tiffStart) => {
    const little = view.getUint16(tiffStart) === 0x4949;
    const u16 = (o) => view.getUint16(o, little);
    const u32 = (o) => view.getUint32(o, little);

    const ifd0 = tiffStart + u32(tiffStart + 4);
    let gpsIfd = null;
    const n = u16(ifd0);
    for (let i = 0; i < n; i++) {
        const entry = ifd0 + 2 + i * 12;
        if (u16(entry) === 0x8825) { gpsIfd = tiffStart + u32(entry + 8); break; }
    }
    if (!gpsIfd) return null;

    const rational = (offset) => u32(offset) / (u32(offset + 4) || 1);
    const dms = (valOffset) => rational(valOffset) + rational(valOffset + 8) / 60 + rational(valOffset + 16) / 3600;

    let lat = null, lng = null, latRef = 'N', lngRef = 'E';
    const gn = u16(gpsIfd);
    for (let i = 0; i < gn; i++) {
        const entry = gpsIfd + 2 + i * 12;
        const tag = u16(entry);
        if (tag === 1) latRef = String.fromCharCode(view.getUint8(entry + 8));
        if (tag === 3) lngRef = String.fromCharCode(view.getUint8(entry + 8));
        if (tag === 2) lat = dms(tiffStart + u32(entry + 8));
        if (tag === 4) lng = dms(tiffStart + u32(entry + 8));
    }
    if (lat == null || lng == null || (lat === 0 && lng === 0)) return null;
    if (latRef === 'S') lat = -lat;
    if (lngRef === 'W') lng = -lng;
    return `${lat.toFixed(5)}, ${lng.toFixed(5)}`;
};

export const readExifGps = (file) => new Promise((resolve) => {
    try {
        const reader = new FileReader();
        reader.onerror = () => resolve(null);
        reader.onload = () => {
            try {
                const view = new DataView(reader.result);
                if (view.getUint16(0) !== 0xFFD8) { resolve(null); return; } // not a JPEG
                let offset = 2;
                while (offset + 4 < view.byteLength) {
                    const marker = view.getUint16(offset);
                    const size = view.getUint16(offset + 2);
                    if (marker === 0xFFE1
                        && view.getUint32(offset + 4) === 0x45786966 /* 'Exif' */) {
                        resolve(gpsFromTiff(view, offset + 10));
                        return;
                    }
                    if ((marker & 0xFF00) !== 0xFF00) break;
                    offset += 2 + size;
                }
                resolve(null);
            } catch (_) { resolve(null); }
        };
        reader.readAsArrayBuffer(file.slice(0, 256 * 1024));
    } catch (_) { resolve(null); }
});
